import { Thumbnail } from '@wix/design-system';
import { assets } from 'config/assets';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectImageStep.scss';

type Props = {
  onItemClick: () => void;
};

export const SelectImageStepOptions: FC<Props> = ({ onItemClick }) => {
  const mediaUrl = useAppStore((state) => state.mediaUrl);
  const setMediaUrl = useAppStore((state) => state.setMediaUrl);

  return (
    <div className={styles.selectImageStepOptions}>
      {assets.map((asset) => (
        <Thumbnail
          onClick={() => {
            onItemClick();
            setMediaUrl(asset.imageUrl);
          }}
          selected={mediaUrl === asset.imageUrl}
          key={asset.imageUrl}
        >
          <div className={styles.selectImageStepOptionsItem}>
            <img src={asset.imageUrl} alt={asset.imageUrl} />
          </div>
        </Thumbnail>
      ))}
    </div>
  );
};
